import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Version } from "../apps-components/apps-types";

/* Reusable component to select item from a list
Parameters:
1) handleSelection = function managing the selection
2) label = label of the list
3) elementList = array containing the different options
*/

function SelectItemFromList(props: {
  handleSelection: any;
  label: string;
  elementList: Array<Version>;
  disabled?: boolean;
  default?: string;
  selected: string;
  error?: boolean;
}) {
  return (
    <Box marginTop={2} sx={{ minWidth: 180 }}>
      <FormControl fullWidth error={props.error}>
        <InputLabel style={{ backgroundColor: "white" }}>
          {props.label}
        </InputLabel>
        <Select
          label={props.label}
          onChange={props.handleSelection}
          defaultValue={props.default}
          value={props.selected}
          disabled={props.disabled}
          key={props.label}
        >
          {props.elementList.map((element) => (
            <MenuItem key={element.id} value={element.id}>
              {element.versionNumber}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
}

export default SelectItemFromList;
